// extracted by mini-css-extract-plugin
module.exports = {"travelGraphsHeading":"TravelGraphsHeading_travelGraphsHeading__1Ul14"};